<template functional>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="props.size" :height="props.size" viewBox="0 0 16 16">
    <g transform="translate(8925 14278)">
      <g transform="translate(-8923.667 -14276.667)">
        <path d="M13.986,9.75,9.91,13.639,7.875,11.694" transform="translate(-4.264 -4.75)" fill="none" stroke="#23d440" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" :style="{ fill: 'none !important' }" />
        <path d="M9.667,16.333A6.667,6.667,0,1,0,3,9.667,6.667,6.667,0,0,0,9.667,16.333Z" transform="translate(-3 -3)" fill="none" stroke="#23d440" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" :style="{ fill: 'none !important' }" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconCircleCheck',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>